import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.FedwireWithdrawResponse,
  FedwireWithdraw: (params: vp.FedwireWithdrawRequest) => void,
  reset: () => void,
  FedwireWithdrawAsync: (params: vp.FedwireWithdrawRequest) => Promise<vp.FedwireWithdrawResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostFedwireWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldFedwireWithdraw, setShouldFedwireWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.FedwireWithdrawRequest>({
    AccountNumber: '',
    ABARoutingNumber: '',
    Amount: 0,
    FirstName: '',
    LastName: '',
    CompanyName: '',
    Address1: '',
    City: '',
    State: '',
    Country: '',
    ZipCode: '',
  });
  const [response, setResponse] = useState<vp.FedwireWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldFedwireWithdraw) return () => {};

    const PostFedwireWithdraw = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postFedwireWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldFedwireWithdraw) void PostFedwireWithdraw();
    setShouldFedwireWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldFedwireWithdraw]);

  return [
    response,
    (_params: vp.FedwireWithdrawRequest) => {
      setParams(_params);
      setShouldFedwireWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldFedwireWithdraw(false);
    },
    async (params: vp.FedwireWithdrawRequest) => {
      return api.postFedwireWithdraw(params, source);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostFedwireWithdraw);
